import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgHome = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 8.80985V17H16V8.80985L11 5.41699L6 8.80985ZM4 7.75L11 3L18 7.75V19H4V7.75Z"
      fill="currentColor"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgHome);

export default ForwardRef;
